import React from 'react';
import PropTypes from 'prop-types';
import ReviewBubble from '@deporvillage/review-bubble-component';
import { I18n } from '@deporvillage/utils-library-component';

import styles from './Reviews.module.scss';

const Reviews = ({ items, count, click }) => (
    <div className={styles['reviews-component']}>
        {
            (items || []).map((item) =>
                <div key={item?.id} className={styles[`reviews-item`]}>
                    {
                        item?.product && <ReviewBubble arrow review={item} />
                    }
                </div>
            )
        }
        {
            items && items.length < count ? (
                <div onClick={click} className={styles['reviews-more']} data-testid="reviews-view-more">
                    <I18n>generic.actions.view_more_reviews</I18n>
                    <div className={`${styles['icon']} icon icon-arrow-down-keyboard`} />
                </div>
            ) : null
        }
    </div>
);

Reviews.propTypes = {
    items: PropTypes.array,
    click: PropTypes.func,
    count: PropTypes.number,
};

export default Reviews;
